import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const isBethcoinPage = (p) => (p.startsWith('/pas') && p !== '/pas') || p.startsWith('/verify-check');

export const BethBanner = () => {
  const { pathname } = useLocation();
  if (!isBethcoinPage(pathname)) return null;
  return (
    <div className="w-full bg-[#141d2e] border-b border-emerald-500/20 print:hidden" data-testid="beth-banner-header">
      <Link to="/" className="block max-w-7xl mx-auto px-4" data-testid="beth-banner-home-link">
        <img src="/banner-strip.png" alt="BETHCOIN Exchange Market" className="h-14 md:h-16 w-auto mx-auto object-contain" />
      </Link>
    </div>
  );
};
